import React from 'react';
import styled from '@emotion/styled'
import { fontSize } from 'style';

import WordCaroussel from './wordCarroussel.component';

const HeroFrontText = ({ text, words }) => (
    <HeroText>
        <Title>
            <WordWrapper>{text}</WordWrapper>
            <WordCaroussel {...{ words }} />
        </Title>
    </HeroText>
);

const HeroText = styled.div`
    h1 {
        font-size: ${fontSize(50)};
        margin: 0;
        font-weight: 300;
        white-space: pre-line;
        max-width: 750px;
    }
    width: 100%;
    justify-content: space-between;

    display: flex;
    align-items: flex-end;
`;

const Title = styled.h1`
    display: flex;
`;

const WordWrapper = styled.span`
    position: relative;
    display: inline-block;
    margin-right: 14px;
    line-height: 1;

    perspective: 20000px;
`;

export default HeroFrontText;
